module.exports = __webpack_public_path__ + "img/support-problem.0397b2fc.svg";